import React from 'react';
import { Price } from '@noths/polaris-client-ribbons-design-system';

import type { ProductState } from 'src/redux/product/types';
import * as styles from './ProductPrice.styles';

export const CURRENT_PRICE_TEST_ID = 'current-price';

export interface ProductPriceProps {
  preSalePrices?: ProductState['preSalePrices'];
  price: ProductState['price'];
  priceIsMinimum?: boolean;
  promoteAsSale?: boolean;
  salePercentage?: number;
}

export const ProductPrice = ({
  preSalePrices,
  price,
  priceIsMinimum = false,
  promoteAsSale = false,
  salePercentage = 0,
}: ProductPriceProps) => {
  const { currency } = price;
  const preSalePrice = preSalePrices?.find((preSalePrice) => preSalePrice.currency === currency);

  return (
    <div css={styles.root}>
      {priceIsMinimum && <span css={styles.from}>From</span>}
      <Price
        amount={price.amount}
        css={styles.currentPrice}
        currency={currency}
        testId={CURRENT_PRICE_TEST_ID}
        type={preSalePrice !== undefined ? 'sale' : 'normal'}
      />
      {(preSalePrice || salePercentage > 0) && (
        <div css={styles.preSaleInfo}>
          {preSalePrice && (
            <Price
              amount={preSalePrice.amount}
              css={styles.previousPrice}
              currency={currency}
              type="previous"
            />
          )}
          {salePercentage > 0 && (
            <span css={[styles.percentageOff, promoteAsSale && styles.percentageOffSale]}>
              {salePercentage}% off
            </span>
          )}
        </div>
      )}
    </div>
  );
};
